import React, { FC, useEffect, useState } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextPropsOptionalVariant } from '@components/Text/Text.types';

interface Props {
  inputString?: string;
  maxChar: number;
  withParenthesis?: boolean;
  textProps?: TextPropsOptionalVariant;
  className?: string;
}

const CharCounter: FC<Props> = ({ inputString, maxChar, withParenthesis, className, textProps = {} }) => {
  const { variant = 'tiny', flavour = 'grey', tag = 'div', ...restTextProps } = textProps;
  const [nbChar, setNbChar] = useState(0);
  useEffect(() => {
    setNbChar(inputString ? inputString.length : 0);
  }, [inputString]);

  return (
    <Text className={className} flavour={flavour} tag={tag} variant={variant} {...restTextProps}>{`${
      withParenthesis ? '(' : ''
    }${nbChar}/${maxChar}${withParenthesis ? ')' : ''}`}</Text>
  );
};

export { CharCounter };
